export const API_BASE_URL = 'https://carabinex.onrender.com';
export const IMAGES_BASE_URL = 'https://carabinex.onrender.com';
export const API_URL = `${API_BASE_URL}/api`;
export const IMAGES_URL = `${API_BASE_URL}/images`;